module.exports = __webpack_public_path__ + "img/uparrow.862428e9.svg";